import * as Yup from "yup";

const CoreSubjectValidationSchema = Yup.object({
  subjectName: Yup.string().trim().required("Category name is required"),

  active: Yup.boolean().required("Active status is required"),
});

const GroupedSubjectValidationSchema = Yup.object({
  groupSubjectTitle: Yup.string().trim().required("Subject name is required"),

  coreSubjectId: Yup.number()
    .typeError("Subject category is required")
    .required("Subject category is required")
    .moreThan(0, "Subject category is required"),

  active: Yup.boolean().required("Active status is required"),
});

const SessionTypeValidationSchema = Yup.object({
  code: Yup.string().trim().required("Code is required"),
  name: Yup.string().trim().required("Name is required"),
  description: Yup.string().trim(),
  durationMinutes: Yup.number()
    .typeError("Duration must be a number")
    .required("Duration is required")
    .moreThan(0, "Duration must be greater than 0"),
  maxParticipants: Yup.number()
    .typeError("Max participants must be a number")
    .required("Max participants is required")
    .moreThan(0, "Max participants must be greater than 0"),
  priceAmount: Yup.number()
    .typeError("Price must be a number")
    .required("Price is required")
    .min(0, "Price cannot be negative"),
  productId: Yup.string().trim().required("Product ID is required"),
  capacityMin: Yup.number()
    .typeError("Minimum capacity must be a number")
    .required("Minimum capacity is required")
    .min(1, "Minimum capacity must be at least 1"),
  lockInMinutesBeforeStart: Yup.number()
    .typeError("Lock-in minutes must be a number")
    .required("Lock-in minutes is required")
    .min(0, "Lock-in minutes cannot be negative"),
  minSessionsPerMonth: Yup.number()
    .typeError("Minimum sessions per month must be a number")
    .min(0, "Cannot be negative"),
  minPrice: Yup.number()
    .typeError("Minimum price must be a number")
    .required("Minimum price is required")
    .min(0, "Cannot be negative"),
  maxPrice: Yup.number()
    .typeError("Maximum price must be a number")
    .required("Maximum price is required")
    .min(0, "Cannot be negative")
    .test(
      "max-gte-min",
      "Maximum price must be greater than or equal to minimum price",
      function (value) {
        const { minPrice } = this.parent;
        if (value == null || value === "" || minPrice == null || minPrice === "")
          return true;
        return Number(value) >= Number(minPrice);
      },
    ),
});

const SessionPackageValidationSchema = Yup.object({
  name: Yup.string().trim().required("Package name is required"),
  sessionTypeId: Yup.number()
    .typeError("Session type is required")
    .required("Session type is required")
    .moreThan(0, "Session type is required"),
  sessionCount: Yup.number()
    .typeError("Session count must be a number")
    .required("Session count is required")
    .moreThan(0, "Session count must be greater than 0"),
  discountPercent: Yup.number()
    .typeError("Discount must be a number")
    .required("Discount is required")
    .min(0, "Discount cannot be negative")
    .max(100, "Discount cannot exceed 100"),
});

export default {
  CoreSubjectValidationSchema,
  GroupedSubjectValidationSchema,
  SessionTypeValidationSchema,
  SessionPackageValidationSchema,
};
